module.exports = __webpack_public_path__ + "static/img/bg-default-mobile.ea7a98cb.png";